// PDF.js (v5 legacy build) は `pdfjs-dist` npm パッケージから直接 import する。
// worker URL は Webpack 5 の `new URL(..., import.meta.url)` 解析を利用するが、
// `import.meta` を含むコードは ts-jest 環境で構文エラーになるため、
// URL 生成のみ `./pdfjs-worker-url.ts` に分離してテスト時にモックする。
import type { PDFDocumentProxy } from "pdfjs-dist";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.mjs";
import { getPdfjsWorkerUrl } from "./pdfjs-worker-url";

let configured = false;

export const getPdfjsLib = async (): Promise<typeof pdfjsLib> => {
  if (!configured) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = getPdfjsWorkerUrl();
    configured = true;
  }
  return pdfjsLib;
};

/**
 * PDF を読み込む。実行時アセット（vite.config.ts が配信する cmaps / wasm）の
 * 参照先をここで補うため、PDF の読み込みは必ずこの関数を経由すること。
 *
 * 特に `wasmUrl` を渡さないと、v5 で WASM 実装になった JBIG2 / CCITTFax / JPEG2000
 * のデコーダを初期化できず、複合機スキャンPDF等が白紙になる。この失敗は警告が出るだけで
 * render の Promise は resolve するため、渡し忘れても例外では気付けない。
 */
export const getPdfDocument = async (params: {
  url: string;
  verbosity?: number;
}): Promise<PDFDocumentProxy> => {
  const pdfjs = await getPdfjsLib();
  return pdfjs.getDocument({
    cMapUrl: "/cmaps/",
    cMapPacked: true,
    wasmUrl: "/wasm/",
    ...params,
  }).promise;
};
